export default "__VITE_ASSET__CWLIK0$5__"